import React from "react";
import {
  DV3ArrowDownIcon,
  DV3CloseIcon,
  FilterIcon,
} from "../../../../common/icons";
import { Modal, Select } from "antd";
import { defineMessages } from "react-intl";
import { translations } from "./constants";

const { Option } = Select;

const messages = defineMessages(translations);

export class FiltersModal extends React.Component {
  state = {
    filters: {
      status: undefined,
      platform: undefined,
      operation: undefined,
    },
    hasChanges: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({
        filters: { ...this.props.initialFilters },
        hasChanges: false,
      });
    }
  }

  handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [key]: value,
      },
      hasChanges: true,
    }));
  };

  onClearFilter = () => {
    this.setState({
      filters: {
        status: undefined,
        platform: undefined,
        operation: undefined,
      },
      hasChanges: true,
    });
  };

  onOK = () => {
    this.props.onChange(this.state.filters);
  };

  render() {
    const {
      visible,
      onCancel,
      intl,
      statusOptions,
      platformOptions,
      operationOptions,
      classes,
    } = this.props;
    const { filters, hasChanges } = this.state;

    return (
      <Modal
        visible={visible}
        footer={null}
        width={500}
        onCancel={onCancel}
        className={classes.modalCustom}
        closeIcon={<DV3CloseIcon />}
        centered
      >
        <div className="header">
          <div className="title">
            <FilterIcon />
            <span>{intl.formatMessage(messages.filter)}</span>
          </div>
        </div>

        <div className="filter-fields">
          <div className="field">
            <div>
              <span className="label">
                {intl.formatMessage(messages.status)}
              </span>
              <Select
                allowClear
                style={{ width: "100%" }}
                placeholder="Selecione"
                value={filters.status}
                onChange={(v) => this.handleFilterChange("status", v)}
                suffixIcon={<DV3ArrowDownIcon />}
              >
                {statusOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="field">
            <div>
              <span className="label">
                {intl.formatMessage(messages.platform)}
              </span>
              <Select
                allowClear
                style={{ width: "100%" }}
                placeholder="Selecione"
                value={filters.platform}
                onChange={(v) => this.handleFilterChange("platform", v)}
                suffixIcon={<DV3ArrowDownIcon />}
              >
                {platformOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="field">
            <div>
              <span className="label">
                {intl.formatMessage(messages.operation)}
              </span>
              <Select
                allowClear
                style={{ width: "100%" }}
                placeholder="Selecione"
                value={filters.operation}
                onChange={(v) => this.handleFilterChange("operation", v)}
                suffixIcon={<DV3ArrowDownIcon />}
              >
                {operationOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </div>

        <div className="buttons-area">
          <button
            type="button"
            className="btn-clear"
            onClick={this.onClearFilter}
          >
            {intl.formatMessage(messages.clear)}
          </button>

          <button
            type="button"
            disabled={!hasChanges}
            className="btn-apply"
            onClick={this.onOK}
          >
            {intl.formatMessage(messages.filterApply)}
          </button>
        </div>
      </Modal>
    );
  }
}
